import { render, staticRenderFns } from "./ExpressList.vue?vue&type=template&id=77d64142&scoped=true&"
import script from "./ExpressList.vue?vue&type=script&lang=js&"
export * from "./ExpressList.vue?vue&type=script&lang=js&"
import style0 from "./ExpressList.vue?vue&type=style&index=0&id=77d64142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d64142",
  null
  
)

component.options.__file = "ExpressList.vue"
export default component.exports